/* PetsPortrait theme: shared helpers, header, countdown, sheets, carousels, cart (no dependencies). */
(function () {
  'use strict';
  const PP = window.PP = window.PP || {};
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const buzz = (p = 8) => { try { navigator.vibrate && navigator.vibrate(p) } catch (e) {} };
  const ease3 = k => 1 - Math.pow(1 - k, 3);
  Object.assign(PP, { RM, $, $$, buzz, ease3 });
  if (PP.t) { const ta = document.createElement('textarea'); Object.keys(PP.t).forEach(k => { ta.innerHTML = PP.t[k]; PP.t[k] = ta.value }) }

  /* ===== money ===== */
  /* the store money format may still carry an old app wrapper (e.g. <span class=transcy-money>), escaped or not: keep only the text */
  PP.cleanMoneyFormat = function (f) {
    return String(f || '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/<[^>]*>/g, '').trim();
  };
  PP.money = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(+cents || 0);
    format = PP.cleanMoneyFormat(format || PP.moneyFormat || '€{{amount_with_comma_separator}}');
    const fmt = (n, dec, th, ds) => {
      dec = dec == null ? 2 : dec; th = th == null ? ',' : th; ds = ds == null ? '.' : ds;
      const fixed = (n / 100).toFixed(dec).split('.');
      const whole = fixed[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return whole + (fixed[1] ? ds + fixed[1] : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2);
      }
    }).replace(/<[^>]*>/g, '');
  };

  PP.countUp = function (el, to, { dur = 1400, dec = 0, sep = true, from = 0 } = {}) {
    const fmt = v => { const s = v.toFixed(dec); return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : s };
    if (RM) { el.textContent = fmt(to); return }
    const t0 = performance.now();
    const f = t => { const k = Math.min(1, (t - t0) / dur); el.textContent = fmt(from + (to - from) * ease3(k)); if (k < 1) requestAnimationFrame(f) };
    requestAnimationFrame(f);
  };
  /* [data-count-up]: counts up to the number written in the element ("21.000+", "21,000+", "21 000+"),
     keeping that thousands separator and any text around it, and ends on the exact original text */
  function countUpText(el) {
    const orig = el.textContent, m = orig.match(/^(\D*)(\d{1,3}(?:([.,   ])\d{3})+|\d+)(\D*)$/);
    if (!m || RM) return;
    const [, pre, num, sep = '', post] = m, to = +num.replace(/\D/g, '');
    const fmt = v => pre + String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, sep) + post;
    el.textContent = fmt(0);
    PP.onView(el, () => {
      const t0 = performance.now(), dur = 1600;
      const f = t => { const k = Math.min(1, (t - t0) / dur); el.textContent = k < 1 ? fmt(to * ease3(k)) : orig; if (k < 1) requestAnimationFrame(f) };
      requestAnimationFrame(f);
      setTimeout(() => { el.textContent = orig }, dur + 400); // ends on the real number even where animation frames are throttled
    });
  }
  PP.countUpText = countUpText;
  PP.onView = function (el, fn, opts = { threshold: .35 }) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) return fn();
    const io = new IntersectionObserver(es => { if (es[0].isIntersecting) { io.disconnect(); fn() } }, opts); io.observe(el);
  };

  /* ===== dates: concept + delivery estimate ===== */
  PP.addWorkdays = function (d, n) { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n-- } return x };
  PP.fmtDate = d => { try { return d.toLocaleDateString(PP.locale || 'nl', { weekday: 'short', day: 'numeric', month: 'short' }) } catch (e) { return d.toDateString() } };
  PP.eta = function () {
    const today = new Date(); const concept = new Date(today); concept.setDate(today.getDate() + (+PP.conceptDays || 1));
    return { concept, deliver: PP.addWorkdays(concept, +PP.deliveryDays || 4) };
  };
  PP.deadlineDate = function (s) { const d = new Date(s || PP.deadline || ''); return isNaN(d) ? null : d };

  PP.fillEta = function (root = document) {
    const { concept, deliver } = PP.eta();
    $$('[data-eta-template]', root).forEach(e => { e.textContent = (e.dataset.etaTemplate || '').replace('[date]', PP.fmtDate(deliver)).replace('[concept]', PP.fmtDate(concept)) });
  };

  /* ===== reveal on scroll ===== */
  let revealIO;
  PP.reveal = function (root = document) {
    const els = $$('.rv, .hl, [data-io]', root).filter(e => !e.classList.contains('in'));
    if (RM || !('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('in')); return }
    revealIO = revealIO || new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target) } }), { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach(e => revealIO.observe(e));
    if (window.Shopify && Shopify.designMode) els.forEach(e => e.classList.add('in'));
  };

  /* ===== bottom sheets (drag the handle down to close) ===== */
  PP.makeSheet = function (sheet, opener) {
    if (!sheet) return null;
    if (sheet._sheet) { opener && opener.addEventListener('click', sheet._sheet.open); return sheet._sheet }
    const scrim = $('#scrim'); let lastFocus;
    const open = () => {
      lastFocus = document.activeElement; sheet.classList.add('on'); scrim && scrim.classList.add('on'); document.body.classList.add('locked');
      if (scrim) scrim._close = close; opener && opener.setAttribute('aria-expanded', 'true');
      setTimeout(() => { const f = sheet.querySelector('h2[tabindex], nav a, a, button:not(.grab), input'); (f || sheet).focus({ preventScroll: true }) }, 80);
    };
    const close = () => {
      sheet.classList.remove('on'); scrim && scrim.classList.remove('on'); document.body.classList.remove('locked'); sheet.style.transform = '';
      opener && opener.setAttribute('aria-expanded', 'false'); lastFocus && lastFocus.focus({ preventScroll: true });
    };
    opener && opener.addEventListener('click', open);
    scrim && scrim.addEventListener('click', () => sheet.classList.contains('on') && close());
    sheet.addEventListener('keydown', e => e.key === 'Escape' && close());
    $$('a[href*="#"]', sheet).forEach(a => a.addEventListener('click', close));
    $$('[data-sheet-close]', sheet).forEach(b => b.addEventListener('click', close));
    const grab = $('.grab', sheet); let y0 = null, dy = 0;
    if (grab) {
      grab.addEventListener('click', () => { if (Math.abs(dy) < 4) close() });
      grab.addEventListener('pointerdown', e => { y0 = e.clientY; dy = 0; sheet.classList.add('drag'); grab.setPointerCapture(e.pointerId) });
      grab.addEventListener('pointermove', e => { if (y0 === null) return; dy = Math.max(0, e.clientY - y0); sheet.style.transform = `translateY(${dy}px)` });
      const up = () => { if (y0 === null) return; y0 = null; sheet.classList.remove('drag'); if (dy > 90) close(); else sheet.style.transform = '' };
      grab.addEventListener('pointerup', up); grab.addEventListener('pointercancel', up);
    }
    sheet._sheet = { open, close };
    return sheet._sheet;
  };

  /* ===== carousel: native snap on touch, mouse drag with momentum, progress, arrows ===== */
  PP.carousel = function (track, bar, arrows) {
    if (!track || track._car) return;
    track._car = true;
    const upd = () => { if (!bar) return; const max = track.scrollWidth - track.clientWidth; const vis = track.clientWidth / Math.max(1, track.scrollWidth); const f = max > 0 ? track.scrollLeft / max : 1; bar.style.transform = `scaleX(${Math.min(1, vis + (1 - vis) * f)})` };
    let raf; track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(upd) }, { passive: true });
    addEventListener('resize', upd); upd(); track._upd = upd;
    const step = () => { const c = [...track.children].find(x => !x.hidden); return c ? c.getBoundingClientRect().width + 16 : 300 };
    arrows && $$('button', arrows).forEach(b => b.addEventListener('click', () => track.scrollBy({ left: +b.dataset.dir * step() * (innerWidth > 980 ? 2 : 1), behavior: RM ? 'auto' : 'smooth' })));
    let down = false, sx, sl, lx, lt, v = 0, moved = 0, mom;
    track.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button) return; down = true; moved = 0; sx = lx = e.clientX; sl = track.scrollLeft; lt = performance.now(); v = 0; cancelAnimationFrame(mom) });
    addEventListener('pointermove', e => {
      if (!down) return; const dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx));
      if (moved > 5) track.classList.add('dragging');
      const now = performance.now(); v = (e.clientX - lx) / Math.max(1, now - lt) * .8 + v * .2; lx = e.clientX; lt = now;
      track.scrollLeft = sl - dx;
    });
    addEventListener('pointerup', () => {
      if (!down) return; down = false;
      if (RM) { track.classList.remove('dragging'); return }
      const glide = () => { v *= .94; track.scrollLeft -= v * 16; if (Math.abs(v) > .04) mom = requestAnimationFrame(glide); else track.classList.remove('dragging') };
      mom = requestAnimationFrame(glide);
    });
    track.addEventListener('click', e => { if (moved > 5) { e.preventDefault(); e.stopPropagation(); moved = 0 } }, true);
    track.addEventListener('dragstart', e => e.preventDefault());
  };

  /* ===== chip group with sliding indicator ===== */
  PP.chipGroup = function (group, onPick) {
    if (!group || group._chips) return; group._chips = true;
    const ind = $('.chip-ind', group), chips = $$('.chip', group);
    const place = instant => {
      const a = chips.find(c => c.getAttribute('aria-pressed') === 'true'); if (!a || !ind) return;
      if (instant) ind.style.transition = 'none';
      ind.style.width = a.offsetWidth + 'px'; ind.style.transform = `translateX(${a.offsetLeft}px)`;
      if (instant) { void ind.offsetWidth; ind.style.transition = '' }
    };
    const pick = (c, silent) => {
      chips.forEach(x => x.setAttribute('aria-pressed', x === c)); place(silent);
      if (!silent) { buzz(); const l = c.offsetLeft - (group.clientWidth - c.offsetWidth) / 2; group.scrollTo({ left: l, behavior: RM ? 'auto' : 'smooth' }) }
      onPick(c.dataset.f, c, silent);
    };
    chips.forEach(c => c.addEventListener('click', () => { if (c.getAttribute('aria-pressed') !== 'true') pick(c) }));
    if (!ind) group.classList.add('no-ind');
    addEventListener('resize', () => place(true));
    (document.fonts ? document.fonts.ready : Promise.resolve()).then(() => place(true));
    place(true);
    group._pick = pick;
  };

  /* ===== announcement bar countdown + [data-days] ===== */
  function initBar() {
    const pad = n => String(n).padStart(2, '0');
    $$('[data-bar]').forEach(bar => {
      if (bar._cd) return; bar._cd = true;
      const end = (PP.deadlineDate(bar.dataset.deadline) || {}).getTime ? PP.deadlineDate(bar.dataset.deadline).getTime() : NaN;
      const cd = $('[data-cd]', bar), before = $('[data-bar-before]', bar), after = $('template[data-bar-after]', bar);
      if (isNaN(end)) { cd && cd.remove(); return }
      (function tick() {
        const ms = end - Date.now();
        if (ms <= 0) {
          if (after && after.innerHTML.trim()) { before.innerHTML = after.innerHTML } else { bar.hidden = true }
          cd && cd.remove(); $$('[data-days]').forEach(e => e.textContent = '0'); return;
        }
        const d = Math.floor(ms / 864e5);
        if (cd) {
          const t = PP.t || {};
          cd.children[0].textContent = d + (t.daysShort || 'd'); cd.children[1].textContent = pad(Math.floor(ms / 36e5) % 24) + (t.hoursShort || 'h');
          cd.children[2].textContent = pad(Math.floor(ms / 6e4) % 60) + (t.minutesShort || 'm'); cd.children[3].textContent = pad(Math.floor(ms / 1e3) % 60) + (t.secondsShort || 's');
        }
        $$('[data-days]').forEach(e => e.textContent = d);
        setTimeout(tick, 1000 - (Date.now() % 1000));
      })();
    });
    if (!$('[data-bar]')) {
      const dl = PP.deadlineDate(); if (!dl) return;
      const d = Math.max(0, Math.floor((dl - Date.now()) / 864e5));
      $$('[data-days]').forEach(e => e.textContent = d);
    }
  }

  /* ===== header: hide on scroll down, show on scroll up ===== */
  function initHeader() {
    const h = $('[data-hdr]'); if (!h || h._init) return; h._init = true;
    let last = scrollY, tk = false;
    addEventListener('scroll', () => {
      if (tk) return; tk = true;
      requestAnimationFrame(() => {
        const y = scrollY;
        h.classList.toggle('scrolled', y > 10);
        if (y > 320 && y > last + 4 && !document.body.classList.contains('locked')) h.classList.add('hide');
        else if (y < last - 4) h.classList.remove('hide');
        last = y; tk = false;
      });
    }, { passive: true });
    PP.makeSheet($('#menuSheet'), $('[data-menu-btn]'));
  }

  /* ===== sticky mobile CTA (home) ===== */
  function initSticky() {
    const bar = $('[data-scta]'); if (!bar || bar._init) return; bar._init = true;
    const vis = new Map();
    const targets = [...$$('[data-sticky-hide]'), $('.ftr')].filter(Boolean);
    const io = new IntersectionObserver(es => { es.forEach(e => vis.set(e.target, e.isIntersecting)); const any = [...vis.values()].some(Boolean); bar.classList.toggle('show', !any && scrollY > 200) }, { threshold: 0 });
    targets.forEach(t => io.observe(t));
    addEventListener('scroll', () => { if (scrollY < 200) bar.classList.remove('show') }, { passive: true });
    document.addEventListener('focusin', e => { if (e.target.matches('input,textarea')) bar.classList.remove('show') });
  }

  /* ===== cart: drawer, page, ajax ===== */
  const Cart = PP.cart = {
    sections() { return [$('[data-cart-drawer]') ? 'cart-drawer' : null, $('[data-main-cart]') ? $('[data-main-cart]').dataset.sectionId : null].filter(Boolean) },
    async fetchJSON(url, body) {
      const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || j.status) { const err = new Error(j.description || j.message || (PP.t && PP.t.error) || 'Error'); err.data = j; throw err }
      return j;
    },
    async add(items, opts = {}) {
      const secs = Cart.sections();
      const j = await Cart.fetchJSON((PP.routes.cartAdd || '/cart/add') + '.js', { items, sections: secs.join(','), sections_url: location.pathname });
      if (j.sections) Cart.render(j.sections);
      else await Cart.refresh();
      Cart.count();
      document.dispatchEvent(new CustomEvent('pp:cart:added', { detail: { items } }));
      if (opts.open !== false) Cart.open();
      return j;
    },
    async change(line, quantity) {
      const secs = Cart.sections();
      const j = await Cart.fetchJSON((PP.routes.cartChange || '/cart/change') + '.js', { line, quantity, sections: secs.join(','), sections_url: location.pathname });
      if (j.sections) Cart.render(j.sections); Cart.setCount(j.item_count);
      return j;
    },
    async note(note) { return Cart.fetchJSON((PP.routes.cartUpdate || '/cart/update') + '.js', { note }) },
    async refresh() {
      const secs = Cart.sections(); if (!secs.length) return;
      const r = await fetch(`${location.pathname}?sections=${secs.join(',')}`); const j = await r.json(); Cart.render(j);
    },
    render(map) {
      Object.keys(map || {}).forEach(id => {
        if (!map[id]) return;
        const doc = new DOMParser().parseFromString(map[id], 'text/html');
        if (id === 'cart-drawer') {
          const fresh = $('[data-cart-drawer-inner]', doc), cur = $('[data-cart-drawer-inner]');
          if (fresh && cur) { cur.replaceWith(fresh); bindCart(fresh) }
        } else {
          const fresh = $('[data-main-cart]', doc), cur = $('[data-main-cart]');
          if (fresh && cur) { cur.replaceWith(fresh); bindCart(fresh) }
        }
      });
      PP.fillEta();
      const c = $('[data-cart-drawer-inner] [data-count]') || $('[data-main-cart] [data-count]');
      if (c) Cart.setCount(+c.dataset.count);
    },
    async count() { try { const r = await fetch((PP.routes.cart || '/cart') + '.js'); const j = await r.json(); Cart.setCount(j.item_count) } catch (e) {} },
    setCount(n) {
      $$('[data-cart-count]').forEach(b => { b.textContent = n; b.hidden = !n; b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop') });
      $$('[data-cart-open]').forEach(a => { const l = a.getAttribute('aria-label') || ''; a.setAttribute('aria-label', l.replace(/\d+/, n)) });
    },
    open() {
      const d = $('[data-cart-drawer]');
      if (!d) { if (PP.cartType === 'page' || !$('[data-main-cart]')) location.href = PP.routes.cart || '/cart'; return }
      d.hidden = false; void d.offsetWidth; d.classList.add('on'); document.body.classList.add('locked');
      Cart._last = document.activeElement; setTimeout(() => { const x = $('[data-cart-close]', d); x && x.focus({ preventScroll: true }) }, 60);
    },
    close() {
      const d = $('[data-cart-drawer]'); if (!d) return;
      d.classList.remove('on'); document.body.classList.remove('locked');
      setTimeout(() => { if (!d.classList.contains('on')) d.hidden = true }, RM ? 0 : 450);
      Cart._last && Cart._last.focus({ preventScroll: true });
    }
  };
  function bindCart(root) {
    $$('[data-qty-line]', root).forEach(w => {
      const line = +w.dataset.qtyLine, out = $('input', w);
      $$('button', w).forEach(b => b.addEventListener('click', async () => {
        const q = Math.max(0, (+out.value || 0) + (+b.dataset.step)); out.value = q; w.closest('[data-line]') && w.closest('[data-line]').classList.add('busy');
        try { await Cart.change(line, q) } catch (e) { alert(e.message) }
      }));
      out.addEventListener('change', async () => { try { await Cart.change(line, Math.max(0, +out.value || 0)) } catch (e) { alert(e.message) } });
    });
    $$('[data-remove-line]', root).forEach(b => b.addEventListener('click', async e => { e.preventDefault(); b.closest('[data-line]').classList.add('busy'); try { await Cart.change(+b.dataset.removeLine, 0) } catch (er) { alert(er.message) } }));
    $$('[data-upsell-add]', root).forEach(b => b.addEventListener('click', async e => {
      e.preventDefault(); b.disabled = true;
      try { await Cart.add([{ id: +b.dataset.upsellAdd, quantity: 1 }], { open: false }) } catch (er) { b.disabled = false; alert(er.message) }
    }));
    $$('[data-cart-note]', root).forEach(t => { let to; t.addEventListener('input', () => { clearTimeout(to); to = setTimeout(() => Cart.note(t.value).catch(() => {}), 500) }) });
    $$('[data-cart-close]', root).forEach(b => b.addEventListener('click', Cart.close));
  }
  function initCart() {
    $$('[data-cart-open]').forEach(a => { if (a._init) return; a._init = true; a.addEventListener('click', e => { if ($('[data-cart-drawer]')) { e.preventDefault(); Cart.open() } }) });
    const d = $('[data-cart-drawer]');
    if (d && !d._init) {
      d._init = true;
      $('.cd-scrim', d) && $('.cd-scrim', d).addEventListener('click', Cart.close);
      d.addEventListener('keydown', e => { if (e.key === 'Escape') Cart.close() });
      bindCart(d);
    }
    const m = $('[data-main-cart]'); if (m && !m._init) { m._init = true; bindCart(m) }
  }

  /* ===== toast ===== */
  PP.toast = function (title) {
    const t = $('#toast'); if (!t) return; if (title) $('[data-toast-title]', t).textContent = title;
    t.classList.add('on'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('on'), 3200);
  };

  /* ===== UploadKit: its app script is printed with data-src by the vendor snippet; load it if nothing else does ===== */
  function loadUploadKit() {
    const s = document.querySelector('script[data-src*="getuploadkit.com"]');
    if (!s || !document.querySelector('.uploadkit')) return;
    setTimeout(() => {
      if (window.UploadKit && (window.UploadKit.loaded || window.UploadKit.app || document.querySelector('script[src*="uploadkit-app"]'))) return;
      const x = document.createElement('script'); x.src = s.dataset.src; x.async = true; document.body.appendChild(x);
    }, 1200);
  }

  /* ===== brand dropdowns: every visible <select> gets our own list; the native select stays underneath for forms and change handlers ===== */
  const FLAG_CODES = ['nl', 'en', 'de', 'fr'];
  const flagHtml = v => { const c = String(v || '').slice(0, 2).toLowerCase(); return FLAG_CODES.includes(c) ? `<span class="flag flag-${c}" aria-hidden="true"></span>` : '' };
  const ddEsc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  let ddOpen = null;
  function ddClose(focusBtn) {
    if (!ddOpen) return;
    const d = ddOpen; ddOpen = null;
    d.classList.remove('open'); d._list.classList.remove('on'); d._btn.setAttribute('aria-expanded', 'false');
    if (focusBtn) d._btn.focus();
  }
  function ddEnhance(sel) {
    if (sel.dataset.dd || sel.closest('.nojs-only') || sel.hasAttribute('data-no-dd')) return;
    sel.dataset.dd = '1';
    const isLang = sel.name === 'locale_code', compact = sel.hasAttribute('data-dd-compact');
    const wrap = document.createElement('div'); wrap.className = 'dd' + (compact ? ' dd-compact' : '');
    sel.parentNode.insertBefore(wrap, sel); wrap.appendChild(sel);
    sel.classList.add('dd-native'); sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    const btn = document.createElement('button'); btn.type = 'button';
    btn.className = compact ? 'icon-btn dd-btn' : 'inp dd-btn' + (sel.classList.contains('lang-select') ? ' lang-select' : '');
    btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    const lbl = sel.id && document.querySelector(`label[for="${sel.id}"]`);
    if (lbl) { lbl.htmlFor = sel.id + '-dd'; btn.id = sel.id + '-dd' } else if (sel.getAttribute('aria-label')) btn.setAttribute('aria-label', sel.getAttribute('aria-label'));
    const list = document.createElement('ul'); list.className = 'dd-list'; list.setAttribute('role', 'listbox'); list.tabIndex = -1;
    wrap.appendChild(btn); document.body.appendChild(list); wrap._btn = btn; wrap._list = list;
    if (compact) list.classList.add('compact');
    const paint = () => {
      const o = sel.options[sel.selectedIndex] || sel.options[0]; if (!o) return;
      btn.innerHTML = compact ? (flagHtml(o.value) || `<b>${ddEsc(o.value.toUpperCase())}</b>`) : `${isLang ? flagHtml(o.value) : ''}<span class="dd-val">${ddEsc(o.textContent)}</span>`;
      if (compact) btn.setAttribute('aria-label', `${sel.getAttribute('aria-label') || ''}: ${o.textContent}`.replace(/^: /, ''));
    };
    const build = () => {
      list.innerHTML = [...sel.options].map((o, i) => `<li role="option" class="dd-opt" data-i="${i}" tabindex="-1" aria-selected="${i === sel.selectedIndex}"${o.disabled ? ' aria-disabled="true"' : ''}>${isLang ? flagHtml(o.value) : ''}<span>${ddEsc(o.textContent)}</span></li>`).join('');
    };
    const pick = i => {
      ddClose(true);
      if (i === sel.selectedIndex) return;
      sel.selectedIndex = i; paint(); buzz();
      sel.dispatchEvent(new Event('input', { bubbles: true })); sel.dispatchEvent(new Event('change', { bubbles: true }));
    };
    const focusOpt = el => {
      if (!el) return; el.focus({ preventScroll: true });
      /* scroll inside the list only: moving the page would close it */
      if (el.offsetTop < list.scrollTop) list.scrollTop = el.offsetTop - 6; else if (el.offsetTop + el.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = el.offsetTop + el.offsetHeight - list.clientHeight + 6;
    };
    btn.addEventListener('click', () => {
      if (ddOpen === wrap) { ddClose(); return }
      ddClose(); build();
      /* the list lives on <body> with fixed position, so no section (transforms, overflow) can cover or clip it */
      wrap._place(true);
      wrap.classList.add('open'); list.classList.add('on'); btn.setAttribute('aria-expanded', 'true'); ddOpen = wrap; wrap._y = scrollY;
      focusOpt($('[aria-selected="true"]', list) || $('.dd-opt', list));
    });
    wrap._place = first => {
      const r = btn.getBoundingClientRect(), up = first ? (r.bottom + 320 > innerHeight && r.top > innerHeight - r.bottom) : list.classList.contains('up');
      list.classList.toggle('up', up);
      list.style.minWidth = r.width + 'px';
      list.style.top = up ? '' : (r.bottom + 8) + 'px'; list.style.bottom = up ? (innerHeight - r.top + 8) + 'px' : '';
      if (compact) { list.style.left = ''; list.style.right = Math.max(8, innerWidth - r.right) + 'px' } else { list.style.right = ''; list.style.left = Math.max(8, Math.min(r.left, innerWidth - 8 - list.offsetWidth)) + 'px' }
    };
    btn.addEventListener('keydown', e => { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); btn.click() } });
    list.addEventListener('click', e => { const li = e.target.closest('.dd-opt'); if (li && !li.hasAttribute('aria-disabled')) pick(+li.dataset.i) });
    let typed = '', typedT;
    list.addEventListener('keydown', e => {
      const opts = $$('.dd-opt', list), cur = opts.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); focusOpt(opts[Math.min(opts.length - 1, cur + 1)]) }
      else if (e.key === 'ArrowUp') { e.preventDefault(); focusOpt(opts[Math.max(0, cur - 1)]) }
      else if (e.key === 'Home') { e.preventDefault(); focusOpt(opts[0]) }
      else if (e.key === 'End') { e.preventDefault(); focusOpt(opts[opts.length - 1]) }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (cur > -1) pick(cur) }
      else if (e.key === 'Escape' || e.key === 'Tab') { if (e.key === 'Escape') e.preventDefault(); ddClose(e.key === 'Escape') }
      else if (e.key.length === 1) {
        clearTimeout(typedT); typed += e.key.toLowerCase(); typedT = setTimeout(() => { typed = '' }, 700);
        focusOpt(opts.find(o => o.textContent.trim().toLowerCase().startsWith(typed)));
      }
    });
    sel.addEventListener('change', paint);
    paint();
  }
  document.addEventListener('click', e => { if (ddOpen && !ddOpen.contains(e.target) && !ddOpen._list.contains(e.target)) ddClose() });
  addEventListener('scroll', () => { if (!ddOpen) return; if (Math.abs(scrollY - ddOpen._y) > 80) ddClose(); else ddOpen._place() }, { passive: true });
  let ddW = innerWidth; addEventListener('resize', () => { if (innerWidth !== ddW) { ddW = innerWidth; ddClose() } else if (ddOpen) ddOpen._place() });
  PP.dropdown = ddEnhance;

  /* buttons can land on the style overview with ?memorial=1 or ?fmt=canvas: keep them on the product the visitor then opens */
  const carry = ['memorial', 'fmt'].map(k => [k, new URLSearchParams(location.search).get(k)]).filter(([, v]) => v);
  if (carry.length) document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="/products/"]'); if (!a) return;
    const u = new URL(a.href, location.href); carry.forEach(([k, v]) => { if (!u.searchParams.has(k)) u.searchParams.set(k, v) }); a.href = u.href;
  }, true);

  /* ===== section registry (theme editor reloads) ===== */
  PP.inits = PP.inits || [];
  PP.register = fn => { PP.inits.push(fn); if (PP._ready) fn(document) };
  PP.initAll = root => { PP.reveal(root); PP.inits.forEach(fn => { try { fn(root) } catch (e) { console.error(e) } }) };
  PP.inits.push(root => $$('select', root).forEach(ddEnhance));
  PP.inits.push(root => $$('[data-count-up]', root).forEach(el => { if (!el.dataset.cu) { el.dataset.cu = '1'; countUpText(el) } }));

  document.addEventListener('click', e => {
    const a = e.target.closest('[data-to-wiz]'); if (!a) return;
    const w = document.querySelector('[data-wiz]'); if (!w) return;
    e.preventDefault(); scrollTo({ top: scrollY + w.getBoundingClientRect().top - 80, behavior: RM ? 'auto' : 'smooth' });
  });

  function boot() {
    initBar(); initHeader(); initSticky(); initCart(); loadUploadKit(); PP.fillEta();
    PP._ready = true; PP.initAll(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', e => { initBar(); initHeader(); initSticky(); initCart(); PP.initAll(e.target) });
  document.addEventListener('shopify:block:select', e => {
    const sc = e.target.closest('.sc'); if (sc) sc.scrollIntoView({ block: 'nearest', inline: 'center' });
  });
})();
